export enum BrandEnum {
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  SHOPIFY = 'shopify',
}
